import { useCallback, useEffect, useState } from 'react'

import { guidedIntakePromoDismissalRepository } from '../../data-access/repositories'

interface IUseGuidedIntakePromoDismissalResult {
  isDismissed: boolean
  dismiss: () => void
}

// The command bar keeps its promo mounted, so a second surface can hold a stale
// copy of the flag; every mounted banner re-reads storage when one dismisses.
const listeners = new Set<() => void>()

export const useGuidedIntakePromoDismissal =
  (): IUseGuidedIntakePromoDismissalResult => {
    const [isDismissed, setIsDismissed] = useState(() =>
      guidedIntakePromoDismissalRepository.isDismissed()
    )

    useEffect(() => {
      const syncFromStorage = () => {
        setIsDismissed(guidedIntakePromoDismissalRepository.isDismissed())
      }

      listeners.add(syncFromStorage)

      return () => {
        listeners.delete(syncFromStorage)
      }
    }, [])

    const dismiss = useCallback(() => {
      guidedIntakePromoDismissalRepository.dismiss()
      listeners.forEach((listener) => listener())
    }, [])

    return { isDismissed, dismiss }
  }
